<template>
  <div>
    <router-view/>
    <div class="service-div">
      <a @click="openChat"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    openChat () {
      // eslint-disable-next-line no-undef
      openJesongChatByGroup(13299, 26753)
    }
  }
}
</script>

<style>
*{
  margin: 0;
  border: 0;
  padding: 0;
}

</style>
<style lang="scss">
  @import "/assets/css/site.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue